import { jsxs, jsx } from "react/jsx-runtime";
const IconSocialXSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M14.096 10.55 20.666 3h-2l-5.404 6.21-3.278-5.267L9.397 3H2.399l1.903 3.057 4.88 7.84L3 21h2l5.016-5.763 3 4.82.587.943h6.998l-1.903-3.057-4.602-7.393Zm.618 8.45-3.324-5.341-.834-1.34L6 5h2.286l3.602 5.788.834 1.34L17 19h-2.286Z" })
    ]
  }
);
export {
  IconSocialXSvg
};
